import React, { useEffect, useState } from 'react';
import { Icon } from '../icon';
import { useWindowSize } from '../../hooks/window-size';
import { PaginationComponent, PagesList, PageLinkAnchor, Etc, PrevPageAnchor, NextPageAnchor } from './mixins';
import { useHistory } from 'react-router-dom';
const createPageArray = (currentPage, totalPages, isTabletPortrait) => {
    const ARRAY_MAX_LENGTH = !isTabletPortrait ? 5 : 9;
    const MIDDLE_POSITION = Math.floor(ARRAY_MAX_LENGTH / 2);
    if (!currentPage)
        return [];
    let pages = [currentPage];
    while (pages[0] > 1 && pages.length < ARRAY_MAX_LENGTH) {
        pages.unshift(pages[0] - 1);
    }
    let nextPagesCount = 0;
    while (pages[pages.length - 1] < totalPages &&
        (pages.length < ARRAY_MAX_LENGTH || nextPagesCount < MIDDLE_POSITION)) {
        pages.push(pages[pages.length - 1] + 1);
        nextPagesCount += 1;
        if (pages.length > ARRAY_MAX_LENGTH)
            pages = pages.splice(1, ARRAY_MAX_LENGTH);
    }
    return pages;
};
const paginateWithoutParams = (page, totalPages) => {
    return `${page <= 1 || page > totalPages ? '' : `?page=${Number(page)}`}`;
};
const paginateWithParams = (params, page) => {
    return `${params}${page <= 1 ? '' : `&page=${Number(page)}`}`;
};
export const PaginationFluid = ({ currentPage, totalPages, states, currentUrl, queryParams, goToPage, loadingMetrics, }) => {
    const { isTabletPortrait } = useWindowSize();
    const [pages, setPages] = useState([]);
    const nextPageDisabled = currentPage >= totalPages || states.loading;
    const prevPageDisabled = currentPage <= 1 || states.loading;
    const history = useHistory();
    // Controlo si la url que recibo tiene la pagina incluida dentro de los filtros (ocurre cuando la url es de Grails)
    const currentUrlGrailsWithoutPage = currentUrl && currentUrl.match(/(.)-pagina-(\d*).html/) && currentUrl.split('-pagina-')[1].split('.')[0] && currentUrl.replace(`-pagina-${currentUrl.split('-pagina-')[1].split('.')[0]}`, '');
    const urlWithoutPage = currentUrlGrailsWithoutPage || currentUrl;
    const createSearchParams = page => {
        if (queryParams) {
            queryParams.delete('page');
            if (queryParams.toString()) {
                return paginateWithParams(queryParams.toString(), page);
            }
        }
        return paginateWithoutParams(page, totalPages);
    };
    const changePage = page => {
        if (goToPage) {
            goToPage(page);
        }
        history.push({
            pathname: urlWithoutPage,
            search: createSearchParams(page),
        });
    };
    useEffect(() => {
        setPages(createPageArray(currentPage, totalPages, isTabletPortrait));
    }, [isTabletPortrait, currentPage, totalPages]);
    useEffect(() => {
        if ((states === null || states === void 0 ? void 0 : states.loading) && loadingMetrics)
            loadingMetrics();
    }, [currentPage, states]);
    return (React.createElement(PaginationComponent, null,
        React.createElement(PrevPageAnchor, { href: prevPageDisabled ? '#' : urlWithoutPage + createSearchParams(currentPage - 1), disabled: prevPageDisabled, onClick: event => {
                event.preventDefault();
                if (prevPageDisabled) {
                    return;
                }
                changePage(currentPage - 1);
            } },
            React.createElement(Icon, { name: "icon-light-caret-left", size: "20", color: "rgba(0, 0, 24, 0.48);" })),
        pages.length && pages[0] > 1 && (React.createElement(React.Fragment, null,
            React.createElement(PagesList, null,
                React.createElement(PageLinkAnchor, { href: urlWithoutPage + createSearchParams(0), onClick: e => {
                        e.preventDefault();
                        changePage(0);
                    } }, 1)),
            React.createElement(Etc, null, "..."))),
        React.createElement(PagesList, null, pages.map(e => (React.createElement(PageLinkAnchor, { key: e, href: urlWithoutPage + createSearchParams(e), disabled: states.loading, isActive: e === currentPage, onClick: event => {
                event.preventDefault();
                changePage(e);
            } },
            React.createElement("span", null, e))))),
        (pages === null || pages === void 0 ? void 0 : pages.length) && pages[pages.length - 1] < totalPages && (React.createElement(React.Fragment, null,
            React.createElement(Etc, null, "..."),
            React.createElement(PagesList, null,
                React.createElement(PageLinkAnchor, { href: urlWithoutPage + createSearchParams(totalPages), onClick: event => {
                        event.preventDefault();
                        changePage(totalPages);
                    } }, totalPages)))),
        React.createElement(NextPageAnchor, { href: nextPageDisabled ? '#' : urlWithoutPage + createSearchParams(currentPage + 1), disabled: nextPageDisabled, onClick: event => {
                event.preventDefault();
                if (nextPageDisabled) {
                    return;
                }
                changePage(currentPage + 1);
            } },
            React.createElement(Icon, { name: "icon-light-caret-right", size: "20", color: "rgba(0, 0, 24, 0.48);" }))));
};
